import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import BrianyCareLogo from "../../assets/auth/BrainyCare-Logo.jpg";
import DrMadhuSign from "../../assets/imaging/madhusign.png";
import { allowedUsers } from '../allowedUsers';
import axios from "axios";
import { getPracticeId } from "../../config/practice";

const ArterialView = () => {
  const { filename } = useParams();
  const [examData, setExamData] = useState(null);

  // Fetch data from API
  const fetchData = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/v1/${getPracticeId()}/imaging/get-image/id`,
        { row_id: parseInt(filename, 10) }
      );

      if (response?.data?.data[0]) {
        const raw = response.data?.data[0];
        const parsedData = JSON.parse(raw.data);
        console.log("ARTERIAL ", parsedData);
        setExamData(parsedData);
      }
    } catch (error) {
      console.error("Error fetching exam data:", error);
    }
  };

  useEffect(() => {
    if (filename) fetchData();
  }, [filename]);
  
  return (
    <div id={examData ? "report-ready" : undefined} className="p-6 bg-white min-h-screen w-full flex justify-center items-center">
      <div className="w-full max-w-4xl flex flex-col border border-gray-300 rounded-md p-8 shadow-sm bg-white">
        {/* Header */}
<div className="flex items-center w-full justify-center">
  {/* Logo */}
  <img
    src={BrianyCareLogo}
    alt="Center for Hypertension & Internal Medicine"
    className="w-16 h-16 mr-4 flex-shrink-0"
  />

  {/* Text Content */}
  <div className="text-left">
    <h1 className="text-[1.5rem] font-semibold leading-tight">
      CENTER FOR HYPERTENSION <br/>& INTERNAL MEDICINE
    </h1>
  </div>
</div>
  <div className="text-center mb-6">
    <p className="text-sm font-medium mt-1">807 N Hancock Ave, Odessa, TX 79761</p>
    <p className="text-sm font-medium mt-1">Ph: 432-582-2446 &nbsp;|&nbsp; Fax: 432-582-2960</p>
  </div>


        {/* Title */}
        <h2 className="text-center font-bold text-base mb-4">ARTERIAL</h2>

        {examData ? (
          <>
            {/* Render Patient Info */}
            <div className="flex justify-start text-sm text-left w-full mb-4">
              <div className="grid grid-cols-[auto_20px_1fr] gap-x-2 gap-y-1">
                <span><strong>MR No#</strong></span><span>:</span><span>{examData.patient_id}</span>
                <span><strong>Name</strong></span><span>:</span><span>{examData.pat_name}</span>
                <span><strong>Age</strong></span><span>:</span><span>{examData.pat_age}</span>
                <span><strong>Exam Date</strong></span><span>:</span><span>{dayjs(examData.examDate).format("MM, DD, YYYY")}</span>
                <span><strong>Date of Birth</strong></span><span>:</span><span>
                  {dayjs(examData.pat_dob).format("MMM D, YYYY")}
                </span>
              </div>
            </div>

            {/* Form data view */}
            <div className="w-full text-start mb-6 text-sm">
              <div className="grid grid-cols-2">
                <div className="mt-2"><strong>Take:</strong> {examData.take || ''}</div>
                <div className="mt-2"><strong>Tape:</strong> {examData.tape || ''}</div>
              </div>
              <div className="grid grid-cols-2">
                <div className="mt-2"><strong>Requested by:</strong> {examData.requestedby || ''}</div>
                <div className="mt-2"><strong>Technician:</strong> {examData.technician || ''}</div>
              </div>
            </div>



  {/* History */}
        <div className="mt-1">
          <h6 className="text-xl font-semibold mb-2 text-start"> History</h6>
            <div className="grid grid-cols-1 mb-3 text-start">
            {Array.isArray(examData.pathistory) && examData.pathistory.length > 0
            ? examData.pathistory.map((hist, index) => (
                <div key={index}>
                  {hist.value || ''}
                </div>
              ))
            : null}
            </div>
        </div>




    <div className="py-1 mt-3">
      {/* RIGHT Section */}
      <div className="grid grid-cols-2 gap-6 mb-2">
        <div className="border text-start">
          <div className="bg-blue-200 text-black p-1"> :: RIGHT</div>
          <div className="space-y-4 p-2">            
            <div className="flex items-start gap-2">
                <label className="text-sm font-medium text-gray-700 w-[30%]">CFA : </label>
                {examData.RIGHT.CFA}
            </div>
            
            <div className="flex items-start gap-2">
                <label className="text-smfont-medium text-gray-700 w-[30%]">PFA : </label>
                {examData.RIGHT.PFA}                
            </div>

            <div className="flex items-start gap-2">
                <label className="text-sm font-medium text-gray-700 w-[30%]"> SFA : </label>
                {examData.RIGHT.SFA}                
            </div>

            <div className="flex items-start gap-2">
                <label className="text-sm font-medium text-gray-700 w-[30%]"> POP : </label>
                {examData.RIGHT.POP}                
            </div>
            <div className="flex items-start gap-2">
                <label className="text-sm font-medium text-gray-700 w-[30%]"> PTA : </label>
                {examData.RIGHT.PTA}        
            </div>
            <div className="flex items-start gap-2">
                <label className="text-sm font-medium text-gray-700 w-[30%]"> ATA : </label>
                {examData.RIGHT.ATA}
            </div>

            <div className="flex items-start gap-2 mt-4">
                <label className="text-sm font-medium text-gray-700 w-[30%]">BP ANKLE : </label>
                {examData.RIGHT.bpankle}
            </div>
            <div className="flex items-start gap-2 mt-4">
                <label className="text-sm font-medium text-gray-700 w-[30%]">BP BRACH : </label>
                {examData.RIGHT.bpbrach}
            </div>
            <div className="flex items-start gap-2 mt-4">
                <label className="text-sm font-medium text-gray-700 w-[30%]">BP ABI : </label>
                {examData.RIGHT.bpabi}
            </div>
          </div>
        </div>

        {/* LEFT Section */}
        <div className="border text-start">
          <div className="bg-blue-200 text-black p-1"> :: LEFT</div>
          <div className="space-y-4 p-2">
            <div className="flex items-start gap-2">
                <label className="text-sm font-medium text-gray-700 w-[30%]">CFA : </label>
                {examData.LEFT.CFA || ''}
            </div>
            
            <div className="flex items-start gap-2">
                <label className="text-sm font-medium text-gray-700 w-[30%]">PFA : </label>
                {examData.LEFT.PFA}
            </div>

            <div className="flex items-start gap-2">
                <label className="text-sm font-medium text-gray-700 w-[30%]"> SFA : </label>
                {examData.LEFT.SFA}
            </div>

            <div className="flex items-start gap-2">
                <label className="text-sm font-medium text-gray-700 w-[30%]"> POP : </label>
                {examData.LEFT.POP}
            </div>
            <div className="flex items-start gap-2">
                <label className="text-sm font-medium text-gray-700 w-[30%]"> PTA : </label>
                {examData.LEFT.PTA}
            </div>
            <div className="flex items-start gap-2">
                <label className="text-sm font-medium text-gray-700 w-[30%]"> ATA : </label>
                {examData.LEFT.ATA}
            </div>

            <div className="flex items-start gap-2 mt-4">
                <label className="text-sm font-medium text-gray-700 w-[30%]">BP ANKLE : </label>
                {examData.LEFT.bpankle}
            </div>
            <div className="flex items-start gap-2 mt-4">
                <label className="text-sm font-medium text-gray-700 w-[30%]">BP BRACH : </label>
                {examData.LEFT.bpbrach}
            </div>
            <div className="flex items-start gap-2 mt-4">
                <label className="text-sm font-medium text-gray-700 w-[30%]">BP ABI : </label>
                {examData.LEFT.bpabi}
            </div>

          </div>
        </div>

      </div>
      </div>




  {/* Technician's Comments Section */}
<div className="py-8">
  <h2 className="text-xl font-semibold text-start"> 
    {allowedUsers.includes(examData?.createdby) ? (
      <div>IMPRESSIONS</div>
    ) : (
      <div>TECHNICIAN COMMENTS</div>
    )}
  </h2>
  <div className="grid gap-6 mb-8">
    <div className="space-y-4 text-start">
      {examData.technicianComments.map((comment) => {
        // Skip rendering if neither text nor value exists
        if (!comment.text && !comment.value) return null;

        return (
          <div key={comment.id}>
            {comment.id === 3 || comment.id === 4 || comment.id === 5 ? (
              // Specific IDs: show text
              <div className="text-start">
                {/* Dropdown on the left can be added if needed */}
                <div className="mt-1 text-sm">{comment.text}</div>
              </div>
            ) : (
              // Other comments: show value
              <div className="text-start">
                <div className="mt-1 text-sm">{comment.value}</div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  </div>
</div>

        {examData ? (
                  <>
            <div className="py-8">
              <div className="flex justify-between items-center">
                <div>
                    {examData?.signoff && (
                      <>
                        <img src={DrMadhuSign} alt="Signed Off" className="ml-2 h-20 inline-block" />
                        <div className="font-semibold">Dr. Madhu Pamganamamula MD FACP FASPC DABOM DABCL CCD</div>
                      </>
                    )}
                </div>
              </div>
            </div>
        </>
        ) : (
         <></>
        )}

          </>
        ) : (
          <p className="text-center text-gray-500">Loading...</p>
        )}
      </div>
    </div>
  );
};

export default ArterialView;